__turbopack_context__.v({
  "actions": "UI-module__LTVKKG__actions",
  "button": "UI-module__LTVKKG__button",
  "buttonSecondary": "UI-module__LTVKKG__buttonSecondary",
  "checkoutButton": "UI-module__LTVKKG__checkoutButton",
  "container": "UI-module__LTVKKG__container",
  "content": "UI-module__LTVKKG__content",
  "infoIcon": "UI-module__LTVKKG__infoIcon",
  "infoList": "UI-module__LTVKKG__infoList",
  "scrollContent": "UI-module__LTVKKG__scrollContent",
  "uiTitle": "UI-module__LTVKKG__uiTitle",
});
